// extracted by mini-css-extract-plugin
export default {"withImage":"ContentfulCtaBanner-module__withImage--OhFPn"};